/* 商品詳細ページ内のレビューリンクと補助 UI を section 単位で扱う */
if (!customElements.get('aureme-product-interactions')) {
  const {
    ColorCardScrollController,
    ModelSpecController,
    ReviewLoginPromptController,
    ReviewSortLabelsController,
    VariantPickerPlacementController,
  } = window.AuremeProductDetail || {};
  const createController = (Controller, host) =>
    typeof Controller === 'function' ? new Controller(host) : undefined;

  customElements.define(
    'aureme-product-interactions',
    class AuremeProductInteractions extends HTMLElement {
      variantChangeUnsubscriber = undefined;
      variantPickerPlacementController = undefined;
      colorCardScrollController = undefined;
      modelSpecController = undefined;
      reviewLoginPromptController = undefined;
      reviewSortLabelsController = undefined;

      handleClick = (event) => {
        const reviewLink = event.target.closest('[data-aureme-review-link]');
        if (reviewLink && this.contains(reviewLink)) {
          this.openReviewAccordion(event);
        }
      };

      handleVariantChange = ({ data }) => {
        if (String(data?.sectionId) !== this.sectionId) return;

        this.colorCardScrollController?.scrollSelectedColorCardIntoView();
        this.modelSpecController?.sync();
      };

      connectedCallback() {
        this.variantPickerPlacementController = createController(
          VariantPickerPlacementController,
          this,
        );
        this.colorCardScrollController = createController(ColorCardScrollController, this);
        this.modelSpecController = createController(ModelSpecController, this);
        this.reviewLoginPromptController = createController(ReviewLoginPromptController, this);
        this.reviewSortLabelsController = createController(ReviewSortLabelsController, this);

        this.variantPickerPlacementController?.connect();
        this.modelSpecController?.connect();
        this.reviewLoginPromptController?.connect();
        this.reviewSortLabelsController?.connect();
        this.addEventListener('click', this.handleClick);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange,
          );
        }

        requestAnimationFrame(() =>
          this.colorCardScrollController?.scrollSelectedColorCardIntoView('auto'),
        );
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.variantPickerPlacementController?.disconnect();
        this.modelSpecController?.disconnect();
        this.reviewLoginPromptController?.disconnect();
        this.reviewSortLabelsController?.disconnect();
        this.variantPickerPlacementController = undefined;
        this.colorCardScrollController = undefined;
        this.modelSpecController = undefined;
        this.reviewLoginPromptController = undefined;
        this.reviewSortLabelsController = undefined;
        this.variantChangeUnsubscriber?.();
      }

      get sectionId() {
        return String(this.dataset.sectionId || '');
      }

      get reviewAccordion() {
        return this.querySelector('[data-aureme-review-accordion]');
      }

      openReviewAccordion(event) {
        event.preventDefault();

        const details = this.reviewAccordion;
        if (!details) return;

        details.open = true;
        details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  );
}
